import React, { useState, useCallback } from 'react';
import { config } from '../../../data/config';
import { invitesStatisticsActions } from './actions';

const StatisticaInvites = () => {
  const [selDist, setSelDist] = useState('all');
  const [infoInvites, setInfoInvites] = useState([]);
  const [loading, setLoading] = useState(false);

  const shNoneInfo = (
    <div className="alert alert-info text-center">
      Не має інформації в обраному періоді
    </div>
  );

  const statusInfo = {
    'invite-sent': 'розглядає',
    'invite-accepted': 'підтверджено'
  };

  const tableInfo = useCallback(() => {
    if (!infoInvites || infoInvites.length === 0) {
      return shNoneInfo;
    }

    let count = 0;

    const tableRows = infoInvites.flatMap((itemGr) => {
      const grNumber = itemGr._id.grNumber;
      const periodGroup = itemGr.groups.length > 0 
        ? itemGr.groups[0].periodFrom + '/' + (parseInt(itemGr.groups[0].periodFrom) + 1) 
        : 'Минулих років';

      return itemGr.requests.map((item) => {
        count += 1;

        return (
          <tr key={`${itemGr._id.kgId}-${item._id}-${count}`}>
            <td className="fw-semibold">{count}</td>
            <td>{itemGr.distr}</td>
            <td className="fw-bold">{itemGr.kgnumber}</td>
            <td>{periodGroup}</td>
            <td className="fw-bold">{grNumber}</td>
            <td>{new Date(item.dateFrom).toLocaleDateString('uk-UK')}</td>
            <td>{new Date(item.dateTo).toLocaleDateString('uk-UK')}</td>
            <td>
              <span className={`badge ${
                item.currentStatus === 'invite-accepted' ? 'bg-success' : 'bg-warning'
              }`}>
                {statusInfo[item.currentStatus] || item.currentStatus}
              </span>
            </td>
            <td>{item.child.firstName}</td>
            <td>{new Date(item.child.birthDate).toLocaleDateString('uk-UK')}</td>
            <td>{item.child.birthCertificate.number}</td>
          </tr>
        );
      });
    });

    return (
      <div className="card mt-4">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <h4 className="text-center mb-4">
                Інформація про запрошення станом на {new Date().toLocaleDateString('uk-UK')}
              </h4>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead className="table-primary">
                <tr>
                  <th scope="col">№</th>
                  <th scope='col'>Район</th>
                  <th scope='col'>ЗДО</th>
                  <th scope='col'>Період</th>
                  <th scope="col">Група</th>
                  <th scope="col">Дата запрошення</th>
                  <th scope="col">Термін</th>
                  <th scope="col">Статус</th>
                  <th scope="col">Ім'я</th>
                  <th scope="col">Дата народження</th>
                  <th scope="col">Свідоцтво</th>
                </tr>
              </thead>
              <tbody>
                {tableRows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }, [infoInvites]);

  const getInfoAboutInvites = useCallback(async () => {
    setLoading(true);
    try {
      const res = await invitesStatisticsActions.getInvitesAll(selDist);
      
      if (res.data && 
          res.data.cursor && 
          Array.isArray(res.data.cursor) && 
          res.data.cursor.length > 0) {
        setInfoInvites(res.data.cursor);
      } else {
        setInfoInvites([]);
      }
    } catch (error) {
      console.error('Error fetching invites:', error);
      setInfoInvites([]);
    } finally {
      setLoading(false);
    }
  }, [selDist]);

  return (
    <div className="container-fluid">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="row g-3 mb-4">
            <div className="col-md-6 col-lg-3">
              <label htmlFor="districtSelect" className="form-label">Район</label>
              <select 
                id="districtSelect"
                className="form-select" 
                value={selDist} 
                onChange={(e) => setSelDist(e.target.value)}
              >
                {config.districts.map((dist, index) => (
                  <option key={index} value={dist}>{dist}</option>
                ))}
                <option value='all'>всі райони</option>
              </select>
            </div>
          </div>

          <div className='row'>
            <div className="col-md-12">
              <button 
                className="btn btn-primary px-4"
                onClick={getInfoAboutInvites} 
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Завантаження...
                  </>
                ) : 'Показати'}
              </button>
            </div>
          </div>

          <div className="mt-4">
            {tableInfo()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticaInvites;